import { Grid, IconButton, Tooltip } from '@material-ui/core'
import Programa from '../../../components/Programa/Programa'
import React, { useCallback, useEffect, useState } from 'react'
import Table from '../../../components/Table/Table'
import { metodoPrograma } from '../../../components/api'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import { Cadastro } from './Cadastro'
import { IoReload } from 'react-icons/io5'

const Empresa = () => {
  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [objeto, setObjeto] = useState([])

  const getLista = useCallback(() => {
    metodoPrograma('lista', {}).then((res) => {
      if (res.status) {
        if (res.lista) {
          setLista(res.lista)
        } else {
          setLista([])
        }
      }
    })
  }, [])

  const handleClick = (_, linha) => {
    setObjeto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela('lista')
    setObjeto([])
    getLista()
  }

  useEffect(() => {
    getLista()
  }, [getLista])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar Estado">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const exclui = (idEmpresa) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja ativar/inativar este registro?',
      )
    )
      return
    await metodoPrograma('exclui', { idEmpresa })
    await getLista()
  }

  return (
    <Programa codigo="CtrlEmpresa" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['Nome', 'Inclusão', 'Exclusão', '']}
              line={(l) => [l[1], l[2], l[3], '']}
              onClick={handleClick}
              columnOptions={[
                {
                  alias: 3,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal[0])}>
                      {linhaOriginal[3] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
            />
          </Grid>
        </Grid>
      ) : (
        <Cadastro {...{ objeto, voltar }} />
      )}
    </Programa>
  )
}

export default Empresa
